module.exports = __webpack_public_path__ + "img/logo-jbs-denim.58578ac9.png";